import { useMemo } from 'react'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

export function useOfficePagePermissions() {
  const { data: loggedUser } = useCurrentUser()

  return useMemo(() => {
    const isAdmin = loggedUser?.permissions['Admin'] || false
    const isSeniorAgent = isAdmin || !!loggedUser?.permissions?.SeniorAgent
    const isAgent = isAdmin || isSeniorAgent || !!loggedUser?.permissions?.Agent
    const isOfficeManager = isAdmin || !!loggedUser?.permissions?.OfficeManager
    const isWarehouseWorker = isAdmin || !!loggedUser?.permissions['Worker'] || isOfficeManager
    const isUSAWorker = isAdmin || (isWarehouseWorker && loggedUser?.warehouse === PkgWarehouse.USA)
    const isGRWorker = isAdmin || (isWarehouseWorker && loggedUser?.warehouse === PkgWarehouse.GR)
    const isUKWorker = isAdmin || (isWarehouseWorker && loggedUser?.warehouse === PkgWarehouse.UK)
    const isPickupOrderDriver = !!loggedUser?.permissions['PickupOrderDriver']
    const isAffiliateManager = !!loggedUser?.permissions['AffiliateManager']

    const isStandardOfficeUser = isAdmin || isWarehouseWorker || isSeniorAgent || isAgent

    return {
      isAdmin,
      isSeniorAgent,
      isWarehouseWorker,
      isAgent,
      isOfficeManager,
      isStandardOfficeUser,

      canViewAddNewPkg: isSeniorAgent || isWarehouseWorker,
      canViewShip: isStandardOfficeUser,
      canViewPkgLocation: isSeniorAgent || isWarehouseWorker,
      canViewBarcodeGunShip: isSeniorAgent || isWarehouseWorker,
      canViewShelfs: isSeniorAgent || isWarehouseWorker,
      canViewPackageRequests: isStandardOfficeUser,
      canApproveOrRejectPkgReq: isSeniorAgent || isWarehouseWorker,
      canViewPkgChecklist: isStandardOfficeUser,
      canViewWarehouseArrivals: isStandardOfficeUser && isGRWorker,
      canViewEditAndUpdate: isStandardOfficeUser,
      canViewServiceReqs: isSeniorAgent,
      canViewPkgLookup: isAgent,
      canViewPkgLookupsList: isUSAWorker || isAgent,
      canViewDelayedPkgs: isSeniorAgent,
      canViewStats: isSeniorAgent || isWarehouseWorker,
      canViewPickupOrders: isAgent || isUKWorker,
      canViewPopularBrandsItems: isSeniorAgent,
      canViewScanPickupOrders: isPickupOrderDriver || isStandardOfficeUser,
      canViewAffiliateManager: isAffiliateManager || isAdmin,
      canViewAdminPages: isSeniorAgent,
      canViewSticker: isWarehouseWorker || isAgent,
    }
  }, [loggedUser])
}
